import el from "@cypherpotato/el";
import { ButtonRow, ToggleButton } from "./button";
import { NumberInput } from "./form";

export function TimeSpanPicker({ value, timeUnits = ["m", "h", "d"] }) {

    var initialValue;
    var initialUnit;

    if (value <= 60 && timeUnits.includes("s")) {
        initialValue = value;
        initialUnit = "s";
    }
    else if (value <= 3600 && timeUnits.includes("m")) {
        initialValue = value / 60;
        initialUnit = "m";
    } else if (value <= 86400 && timeUnits.includes("h")) {
        initialValue = value / 3600;
        initialUnit = "h";
    } else {
        initialValue = value / 86400;
        initialUnit = "d";
    }

    const selectedValue = el.state.create(initialValue);
    const currentUnit = el.state.create(initialUnit);

    const unitMultiplier = () => {
        switch (currentUnit.value) {
            case "d":
                return 86400.0;
            case "h":
                return 3600.0;
            case "m":
                return 60.0;
            case "s":
                return 1.0;
        }
    }

    return el.state.listening([selectedValue, currentUnit], () =>
        el("div.time-span-picker[form-slot]",
            {
                $properties: {
                    value: {
                        get() {
                            return selectedValue.value * unitMultiplier();
                        },
                        set(value) {
                            selectedValue.value = value / unitMultiplier();
                        }
                    }
                }
            },
            NumberInput({
                value: selectedValue.value,
                min: 0.01,
                max: 1_000_000_000,
                step: currentUnit.value == "s" ? 1 : 0.01,
                onChange(value) {
                    if (value != selectedValue.value)
                        selectedValue.value = value;
                }
            }),
            ButtonRow(
                timeUnits.includes("d") && ToggleButton("Days", {
                    value: currentUnit.value === "d",
                    onClick() {
                        currentUnit.value = "d";
                    }
                }),
                timeUnits.includes("h") && ToggleButton("Hours", {
                    value: currentUnit.value === "h",
                    onClick() {
                        currentUnit.value = "h";
                    }
                }),
                timeUnits.includes("m") && ToggleButton("Minutes", {
                    value: currentUnit.value === "m",
                    onClick() {
                        currentUnit.value = "m";
                    }
                }),
                timeUnits.includes("s") && ToggleButton("Seconds", {
                    value: currentUnit.value === "s",
                    onClick() {
                        currentUnit.value = "s";
                    }
                })
            )
        )
    );
}